//// Configuracion de Produccion //////
//// No modificar ************** //////
export const AuthApi = "https://prodauthapi.netizar.com/api/";
export const UrlApi = "https://prodapi.netizar.com/api";
export const MailApi = "https://uservices.netizar.com";
export const SmsApi = "https://sms.netizar.com/api";
export const titulonavbar = "Producción"
export const UrlApp = "https://prod.netizar.com/"
export const UrlApiEnvasado = "https://apienvasado.netizar.com/";
export const UrlFacturacion = "http://192.168.0.22:8120"  /// 8120 es el puerto para produccion 
export const TelemetriaApi = "https://192.168.0.22:3536/api"
export const UrlPortalProveedores = "http://proveedores.netizar.com";
////////////////////////////////////////